import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Element from 'element-ui'
import swal from 'sweetalert';

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: Home,
  //   redirect:'/secure'    //默认重定向到secure
  // },
  {
    path: '*',
    name: '/',
    redirect: '/'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    redirect: '/secure',    //默认重定向到secure
    children: [
      // 订购产品
      { path: '/order', name: 'order', component: () => import('../views/product/order.vue') },
      // 轻量云
      { path: '/LightweightCloud', name: 'LightweightCloud', component: () => import('../views/product/LightweightCloud.vue') },
      // 云电脑服务器
      { path: '/cloudPC', name: 'cloudPC', component: () => import('../views/product/CloudPC.vue') },
      // 云电脑详情
      { path: '/cloudPCDetails', name: 'cloudPCDetails', component: () => import('../views/product/CloudPCDetails.vue'), meta: { menuIndex: '/cloudPC' } },
      // 云电脑屏幕墙
      { path: '/screenWall', name: 'screenWall', component: () => import('../views/product/ScreenWall.vue'), meta: { menuIndex: '/cloudPC' } },
      // 轻量云详情 LightweightDetails
      {
        path: '/LightweightDetails', name: 'LightweightDetails', component: () => import('../views/product/LightweightDetails.vue'),
        meta: {
          menuIndex: '/LightweightCloud'
        }
      },
       // 显卡云 graphicsCloud
       { path: '/graphicsCloud', name: 'graphicsCloud', component: () => import('../views/product/graphicsCloud.vue') },
       {
         path: '/graphicsDetails', name: 'graphicsDetails', component: () => import('../views/product/graphicsDetails.vue'),
         meta: {
           menuIndex: '/graphicsCloud'
         }
       },
       // 块存储页面 blockStorage
       { path: '/blockStorage', name: 'blockStorage', component: () => import('../views/product/blockStorage.vue') },
       // 创建云盘页面 blockAddCloud
       { path: '/blockAddCloud', name: 'blockAddCloud', component: () => import('../views/product/blockAddCloud.vue'),
         meta:{
           menuIndex:'/blockStorage'
         }
       },
      
      // 云服务器
      { path: '/server', name: 'server', component: () => import('../views/product/server.vue') },
      // 云服务器产品详情  
      {
        path: '/cloudDeta', name: 'cloudDeta', component: () => import('../views/product/cloudDeta.vue'),
        meta: {
          menuIndex: '/server'
        }
      },
      // 产品详情 
      {
        path: '/serverEdit', name: 'serverEdit', component: () => import('../views/product/serverEdit.vue'),
        meta: {
          menuIndex: '/independence'
        }
      },
      // 套餐升降级 
      { path: '/improve', name: 'improve', component: () => import('../views/product/improve.vue'),
      meta:{
        menuIndex:'/independence'
      }
      },
      // 独立服务器
      { path: '/independence', name: 'independence', component: () => import('../views/product/independence.vue') },
      // 模型平台
      { path: '/model', name: 'model', component: () => import('../views/product/model.vue') },
      // AI 大模型
      { path: '/ai', name: 'ai', component: () => import('../views/product/AiModels.vue') },
      // 应用加速 (belong=6)
      { path: '/applicationAccelerate', name: 'applicationAccelerate', component: () => import('../views/product/applicationAccelerate.vue') },
      // 应用加速详情 (总揽 / 数据 / 规则)
      {
        path: '/applicationAccelerateDetail',
        name: 'applicationAccelerateDetail',
        component: () => import('../views/product/applicationAccelerateDetail.vue'),
        meta: { menuIndex: '/applicationAccelerate' }
      },
      // 亿信盾
      // 边缘加速YCDN  
      { path: '/Ycdn', name: 'Ycdn', component: () => import('../views/product/Ycdn/Ycdn.vue') },
      // YCDN详情 
      {
        path: '/addSite', name: 'addSite', component: () => import('../views/product/Ycdn/addSite.vue'),
        meta: {
          menuIndex: '/Ycdn'
        }
      },
      // 其他服务器 
      { path: '/otherProduct', name: 'otherProduct', component: () => import('../views/product/otherProduct.vue') },
      // 机柜租用
      { path: '/cabinet', name: 'cabinet', component: () => import('../views/product/cabinet.vue') },
      // 防火墙查询  
      { path: '/firewall', name: 'firewall', component: () => import('../views/product/firewall.vue') },
      // 机柜租用详情 cabinetEdit
      {
        path: '/cabinetEdit', name: 'cabinetEdit', component: () => import('../views/product/cabinetEdit.vue'),
        meta: {
          menuIndex: '/cabinet'
        }
      },
      {
        path: '/orderdetail', name: 'orderdetail', component: () => import('../views/product/orderdetail.vue'),
        meta: {
          menuIndex: '/order'
        }
      },
      // 实名认证
      { path: '/authentication', name: 'authentication', component: () => import('../views/account/authentication.vue') },
      // 个人信息
      { path: '/person', name: 'person', component: () => import('../views/account/person.vue') },
      // 安全中心 
      { path: '/secure', name: 'secure', component: () => import('../views/account/secure.vue') },
      //帐单列表
      { path: '/billList', name: 'billList', component: () => import('../views/finance/billList.vue') },
      // 流量费用账单
      { path: '/trafficBillList', name: 'trafficBillList', component: () => import('../views/finance/trafficBillList.vue') },
      // 帐单列表查看详情 
      {
        path: '/billListEdit', name: 'billListEdit', component: () => import('../views/finance/billListEdit.vue'),
        meta: {
          menuIndex: '/billList'
        }
      },
      // 账户充值 
      { path: '/recharge', name: 'recharge', component: () => import('../views/finance/recharge.vue') },
      // 交易记录
      { path: '/record', name: 'record', component: () => import('../views/finance/record.vue') },
      // 流量费用流水
      { path: '/trafficRecord', name: 'trafficRecord', component: () => import('../views/finance/trafficRecord.vue') },
      // 大模型费用记录
      { path: '/modelRecord', name: 'modelRecord', component: () => import('../views/finance/modelRecord.vue') },
      // 付款页面 viewcart
      {
        path: '/viewcart', name: 'viewcart', component: () => import('../views/product/viewcart.vue'),
        meta: {
          menuIndex: '/billList'
        }
      },
      { path: '/dome', name: 'dome', component: () => import('../views/product/dome.vue') },
      // 支付成功页面 

      { path: '/paysuccess', name: 'paysuccess', component: () => import('../views/product/paysuccess.vue') },
      // 工单页面 
      { path: '/work', name: 'authenticworkation', component: () => import('../views/account/work.vue'), },
      // 新增工单
      { path: '/addWork', name: 'addWork', component: () => import('../views/account/addWork.vue'),
        meta: {
          menuIndex: '/work'
        }
      },
      // 工单详情workDateli
      {
        path: '/workDateli', name: 'workDateli', component: () => import('../views/account/workDateli.vue'),
        meta: {
          menuIndex: '/work'
        }
      },
      // 消息列表 messageList
      { path: '/messageList', name: 'messageList', component: () => import('../views/account/messageList.vue') },
      // 优惠卷列表 
      { path: '/coupon', name: 'coupon', component: () => import('../views/account/coupon.vue') },
      // 域名白名单 whiteList
      { path: '/whiteList', name: 'whiteList', component: () => import('../views/website/whiteList.vue') },
      // 开访文档 openDocument
      { path: '/openDocument', name: 'openDocument', component: () => import('../views/website/openDocument.vue') },
      // 生成appid 
      { path: '/createAppid', name: 'createAppid', component: () => import('../views/website/createAppid.vue') },
      // 漏洞提醒 loophole
      { path: '/loophole', name: 'loophole', component: () => import('../views/website/loophole.vue') },
      // 库存列表 inventory
      { path: '/inventory', name: 'inventory', component: () => import('../views/website/inventory.vue') },
      

      // 威胁检测- 安全总览
      { path: '/securityOverview', name: 'securityOverview', component: () => import('../views/threat/securityOverview.vue') },
    ]
  },
  // 手机端实名认证成功 mobileAuthentication
  { path: '/mobileAuthentication', name: 'mobileAuthentication', component: () => import('../views/mobileAuthentication.vue') },
  // VNC页面 noVNC
  { path: '/noVNC', name: 'noVNC', component: () => import('../views/noVNC.vue') },
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: 'history', // 或者 'hash'
  routes
})


// 获取url参数的token方法
function getQueryString(name) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  let r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  };
  return null;
}
// sub15376803076
router.beforeEach((to, from, next) => {
  if (to.path === '/mobileAuthentication' || to.path === '/noVNC') {
    next();
    return; // 终止后续逻辑
  }

  // console.log(to);
  // console.log(to.query.saleId,'销售ID');
  // 登录之后检测有token就不跳到login页面,如果没有token就必须跳到登录
  /* 必须调用 `next` */
  let token = localStorage.getItem('customlogintoken')

  if (to.path === '/login') {
    // 判断以该客户登录
    let Ctoken = getQueryString("token");
    console.log(Ctoken);
    let cid = getQueryString("cid");
    console.log("token=" + Ctoken);
    if (Ctoken != null && Ctoken.trim().length > 0) {
      console.log(cid);
      localStorage.setItem("customlogintoken", Ctoken);
      localStorage.setItem("customusernametitle", cid);
      router.push("/secure");
      return;
    }
    // 判断有没有token
    if (token) {
      next('/secure')
      setTimeout('console.clear()', 300)
    } else {
      next()
      // console.log(to, from, next);
    }
  } else {
    if (token == null || token == undefined || token == '') {
      next({ path: '/login' })
      localStorage.clear();
    } else {
      //-----------------------------------------
      if (localStorage.getItem('usersublogin') == '1') {
        // next();
        if (to.path == '/whiteList' || to.path == '/firewall' || to.path == '/securityOverview') {
          next()
        } else {
          next('/whiteList')
        }
      } else if (localStorage.getItem('isReal') == '1' || to.path == '/secure' || to.path == '/authentication') {
        next();
      } else {
        swal({
          title: "请先实名认证",
          text: "Please authenticate your real name first!",
          icon: "warning",
          buttons: {
            cancel: "取消",
            confirm: {
              text: "确认",
              value: true,
              visible: true,
              className: "btn-confirm",
            }
          },
          // dangerMode: true,
        }).then((willDelete) => {
          if (willDelete) {
            // 在这里执行确认按钮点击后的操作
            // swal("Poof! Your imaginary file has been deleted!", {
            //   icon: "success",
            // });
            // localStorage.setItem("isReal","1")
            // console.log("isreal:"+localStorage.getItem("isReal"));

            next('/authentication')

          } else {
            // swal("Your imaginary file is safe!");
          }
        })
      }
    }

  }
})
//后置守卫
router.afterEach((to, from) => {
  // document.title = to.meta.title || '亿信通-客户管理系统'
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, resolve, reject) {
  if (resolve || reject) return originalPush.call(this, location, resolve, reject)
  return originalPush.call(this, location).catch((e) => { console.log(123); })
}



export default router
